import apiRequest from '@app/utils/apiRequest';
import {CANDIDATE_FILES} from "@app/constants/Fields";
import {cloneDeep} from "lodash";
import {ResponseCode} from "@app/constants/Common";

export const requestCandidates = (params) => apiRequest.get(`/candidate/list/`, {params: params});

export const checkPermissionShowCandidate = (candidateId) =>
    apiRequest.get(`/candidate/detail/check-permission-show-candidate`, {params: {candidate_id: candidateId}});

export const getMaxUpdateYear = (candidateId) =>
    apiRequest.get(`/candidate/detail/max-update-year`, {params: {candidate_id: candidateId}});

export const getCandidateGeneralDetail = (candidateId) =>
    apiRequest.get(`/candidate/detail/general`, {params: {candidate_id: candidateId}});

export const getCandidatePersonalDetail = (candidateId) =>
    apiRequest.get(`/candidate/detail/personal`, {params: {candidate_id: candidateId}});

export const getCandidateReferChecksDetail = (candidateId) =>
    apiRequest.get(`/candidate/detail/refer-check`, {params: {candidate_id: candidateId}});

export const getCandidateNotesDetail = (candidateId) =>
    apiRequest.get(`/candidate/detail/note`, {params: {candidate_id: candidateId}});

export const getCandidateProcessNotes = (candidateId, userId) =>
    apiRequest.get(`/candidate/detail/process-note`, {params: {candidate_id: candidateId, user_id: userId}});

export const getCandidateLanguages = (candidateId, isAllUsers) =>
    apiRequest.get(`/candidate/detail/languages`, {params: {candidate_id: candidateId, is_all_users: isAllUsers}});

export const getQuickShotDetail = (candidateId) =>
    apiRequest.get(`/candidate/detail/quick-shot`, {params: {candidate_id: candidateId}});

export const getCustomNotesDetail = (candidateId) =>
    apiRequest.get(`/candidate/detail/custom-notes`, {params: {candidate_id: candidateId}});

export const getContactPointDetail = (candidateId) =>
    apiRequest.get(`/candidate/detail/contact-points`, {params: {candidate_id: candidateId}});

export const getCandidateCareerDetail = (candidateId) =>
    apiRequest.get(`/candidate/detail/career-summary`, {params: {candidate_id: candidateId}});

export const getCandidateContactDetail = (candidateId) =>
    apiRequest.get(`/candidate/detail/contact`, {params: {candidate_id: candidateId}});

export const getCandidateCVDetail = (candidateId) =>
    apiRequest.get(`/candidate/detail/curriculum-vitae`, {params: {candidate_id: candidateId}});

export const getCandidateRelationsDetail = (candidateId) =>
    apiRequest.get(`/candidate/detail/relation`, {params: {candidate_id: candidateId}});

export const getCandidateLocationDetail = (candidateId, isAllUsers) =>
    apiRequest.get(`/candidate/detail/location`, {params: {candidate_id: candidateId, is_all_users: isAllUsers}});

export const getCandidateCategoryDetail = (candidateId, isAllUsers) =>
    apiRequest.get(`/candidate/detail/category`, {params: {candidate_id: candidateId, is_all_users: isAllUsers}});

export const getCandidateFlowDetail = (candidateId) =>
    apiRequest.get(`/candidate/detail/flow`, {params: {candidate_id: candidateId}});

export const getJobSendRequestInputHistory = (candidateId) =>
    apiRequest.get(`/candidate/detail/job-send-request-history`, {params: {candidate_id: candidateId}});

export const getJobSendRequestInputNotes = (candidateId) =>
    apiRequest.get(`/candidate/detail/job-send-request-notes`, {params: {candidate_id: candidateId}});

export const getHideCandidateUsers = (candidateId) =>
    apiRequest.get(`/candidate/detail/hide-users`, {params: {candidate_id: candidateId}});

export const getJobSeeking = (candidateId) =>
    apiRequest.get(`/candidate/detail/job-seeking`, {params: {candidate_id: candidateId}});

export const getJobFindModeHistories = (candidateId) =>
    apiRequest.get(`/candidate/detail/job-find-mode-history`, {params: {candidate_id: candidateId}});

export const getInfoAsCtv = (candidateId) =>
    apiRequest.get(`/candidate/info-as-ctv`, {params: {candidate_id: candidateId}});

export const getCandidateOrigin = (candidateId) =>
    apiRequest.get(`/candidate/detail/origin-info`, {params: {candidate_id: candidateId}});

export const requestUploadCV = (data) =>
    apiRequest.post(`/candidate/upload-cv`, data);

export const saveCandidateNewInput = (data) =>
    apiRequest.post(`/candidate/save-candidate-new-input`, data);

export const checkExists = (data) =>
    apiRequest.post(`/candidate/check-exists`, data);

export const referCheck = (data) =>
    apiRequest.post(`/candidate/has-prefer-check`, data);

// update and override
export const updateCandidateNotesDetail = (data) =>
    apiRequest.post(`/candidate/detail/note`, data);

// update and override
export const updateCandidateProcessNotes = (data) =>
    apiRequest.post(`/candidate/detail/process-note`, data);

// update and override
export const updateCandidateLanguages = (data) =>
    apiRequest.post(`/candidate/detail/languages`, data);

// update and override
export const updateCandidateGeneralDetail = (data) =>
    apiRequest.post(`/candidate/detail/general`, data);

// update and override
export const updateQuickShotDetail = (data) =>
    apiRequest.post(`/candidate/detail/quick-shot`, data);

// update and override
export const updateCustomNoteDetail = (data) =>
    apiRequest.post(`/candidate/detail/custom-notes`, data);

export const requestUpdateCddSummaries = (data) =>
    apiRequest.post(`/candidate/detail/cdd-summaries`, data);

// update and override
export const updateContactPointDetail = (data) =>
    apiRequest.post(`/candidate/detail/contact-points`, data);

// update and override
export const updateCandidateCareerDetail = (data) =>
    apiRequest.post(`/candidate/detail/career-summary`, data);

// update and override
export const updateCandidateContactDetail = (data) =>
    apiRequest.post(`/candidate/detail/contact`, data);

// update and override
export const updateCandidateReferChecksDetail = (data) =>
    apiRequest.post(`/candidate/detail/refer-check`, data);

// update and override
export const updateCandidatePersonalDetail = (data) =>
    apiRequest.post(`/candidate/detail/personal`, data);

// update and override
export const updateCandidateLocationDetail = (data) =>
    apiRequest.post(`/candidate/detail/location`, data);

// update and override
export const updateCandidateCategoriesDetail = (data) =>
    apiRequest.post(`/candidate/detail/category`, data);

// update and override
export const updateCandidateFlowsDetail = (data) =>
    apiRequest.post(`/candidate/detail/flow`, data);

// update job send request notes
export const updateJobSendRequestNotes = (data) =>
    apiRequest.post(`/candidate/detail/job-send-request-notes`, data);

// update and override
export const updateCandidateCVDetail = (data) =>
    apiRequest.post(`/candidate/detail/curriculum-vitae`, data);

// update and override
export const updateCandidateRelationsDetail = (data) =>
    apiRequest.post(`/candidate/detail/relation`, data);

// update and override
export const updateJobSeekingDetail = (data) =>
    apiRequest.post(`/candidate/detail/job-seeking`, data);

// update and override
export const updateCandidateOrigin = (data) =>
    apiRequest.post(`/candidate/detail/origin-info`, data);

export const requestGetCandidateDVTJCUV = (candidateId) =>
    apiRequest.get(`/candidate/detail/candidate-dvtjcuv`, {params: {candidate_id: candidateId}});
export const requestUpdateCandidateDVTJCUV = (data) =>
    apiRequest.post(`/candidate/detail/candidate-dvtjcuv`, data);

// update and override
export const updateInfoAsCtv = (data) =>
    apiRequest.post(`/candidate/info-as-ctv`, data);

export const deleteCandidateCV = (data) =>
    apiRequest.delete(`/candidate/detail/curriculum-vitae`, {data: data});

export const requestGetCandidateInputInfo = (params) =>
    apiRequest.get(`/candidate/input-info`, {params: params});

// update and override
export const saveShowHideCandidates = (data) =>
    apiRequest.post(`/candidate/show-hide-candidate`, data);


export const searchAllInputInfo = async (candidateId, inputInfoType) => {
    if (!inputInfoType) {
        alert("Vui lòng nhập loại dữ liệu")
        return [];
    }

    let params = {candidate_id: candidateId, input_type: inputInfoType}
    const res = await requestGetCandidateInputInfo(params);
    if (res.sts_code === ResponseCode.SUCCESS) {
        return res.content
    }
    return []
    // let items = {}
    // if (resContents && resContents.length > 0) {
    //     for (let i=0; i < resContents.length; i++) {
    //         const row = resContents[i]
    //         Object.keys(row).forEach(key =>{
    //             if (!items[key]) {
    //                 items[key] = []
    //             }
    //             if (CANDIDATE_FILES[key]) {
    //                 items[key].push({
    //                     title: CANDIDATE_FILES[key].name,
    //                     values: row[key],
    //                     created_user: row.created_user,
    //                     updated_time: row.updated_date_time,
    //                 })
    //             }
    //         })
    //     }
    // }
    // return items
}


export const requestGetCandidateCareerRefCheck = (candidateSummaryId) =>
    apiRequest.get(`/candidate/detail/career-summary-ref-check`, {params: {career_summary_id: candidateSummaryId}});

export const requestDownloadCandidateCareerRefCheckFile = (refCheckId) =>
    apiRequest.get(`/candidate/detail/career-summary-ref-check-file`, {params: {ref_check_id: refCheckId}});

export const requestUpdateCandidateCareerRefCheck = (data) =>
    apiRequest.post(`/candidate/detail/career-summary-ref-check`, data);

export const requestDeleteCandidateCareerRefCheck = (data) =>
    apiRequest.delete(`/candidate/detail/career-summary-ref-check`, data);
